module.exports = __webpack_public_path__ + "static/media/card_suits_heart.37bcd9aa.png";